export default "__VITE_ASSET__Ci7ksFhj__"